import { useNavigate, useParams } from "react-router-dom";
import { Modal, ModalContent, ModalFooter, ModalHeader } from "./SuccessLayout";
import { API_ENDPOINTS, aspetto_logo } from "../constant/_constant";
import useGetRequest from "../hooks/useGetRequest";
import { useState } from "react";
import mail_successfully from "../assets/mail_successfully.svg";
import Lottie from "lottie-react";
import animationData from "../assets/rfq_successfuly.json";

function SuccsessMsgModal({ show, onHide, title, message, btntext, newbtn, onSecondaryBtnClick }) {
  return (
    <Modal isOpen={show} onClose={onHide}>
      <ModalContent>
        <div className="text-center w-50 mb-3 m-auto">
          <Lottie
            animationData={animationData}
            loop={true}
            autoplay={true}
            style={{ height: 150 }}
          />
        </div>
        <h2 className="text-center mb-3">{title}</h2>
        {/* <p className="text-center"> {message}</p> */}
        <p
          className="text-center"
          dangerouslySetInnerHTML={{ __html: message }}
        ></p>
        <div className="d-flex justify-content-center gap-2">
          <button
            className="btn w-100 btn-warning mb-6 mt-3"
            onClick={onHide}
          >
            {btntext}
          </button>
          {newbtn && (
            <button
              className="btn w-100 btn-outline-warning mb-6 mt-3"
              onClick={onSecondaryBtnClick}
            >
              {newbtn}
            </button>
          )}
        </div>
        {/* <button
          className="btn w-100 btn-warning mb-6 mt-3"
          onClick={onHide}
          // disabled={isLoading}
        >
          {btntext}
        </button> */}
      </ModalContent>
    </Modal>
  );
}

export default SuccsessMsgModal;
